import API from "../../api";
import BorderlessButton from "../Button/BorderlessButton";
import styles from "./TopBar.module.css";

function TopBar({ title, rightActions, showBottomLine }) {
  return (
    <div className={`${styles.topbar} ${showBottomLine ? styles.bottomLine : ""}`}>
      <span className={styles.title}>
        <img src="/logo192.png" width={27} height={27} alt="logo"></img>
        {title}
      </span>

      <div className={styles.buttonActions}>{rightActions}</div>
    </div>
  );
}

export default TopBar;
